import React, { useContext } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

import ModalContext from "store/ModalContext";
import AdministratorNewEditForm from "./AdministratorNewEditForm";
//import { useHistory } from 'react-router';
//import certificatesService from "services/certificates.service";


const AdministratorRow = ({
  item,
  onSubmitted,
  props,
}) => {
  const { openModal } = useContext(ModalContext);
  //const history = useHistory();  

  const handleDeleteUser = (user) => {
    openModal(
      <div>
        <div>Are you sure you want to delete the user?</div>
        <div className="fw-bold text-center">{user.userName}</div>
      </div>,
      "Delete Admin",
      { submitLabel: "Yes", cancelLabel: " No" }
    )
      .then((res) => onSubmitted(user, "delete"))
      .catch((err)=>{});
  };

  const redirectToViewFlightsForAirline = (airlineCode) => {
    props.history.push({
      pathname: "/FlightList",
      state: { airlineCode },
    });
  };
  const redirectToActivityLog = (item) => {
    props.history.push({
      pathname: `/ActivityLogForUser/${item.userName}`,
    });
  };

  const updateAdmin = (admin) => {
    openModal(
      <AdministratorNewEditForm adminUser={admin} />,
      "Update Admin",
      { showActions: false }
    )
      .then((data) => {
        onSubmitted(data, "refresh");
      })
      .catch((err)=>{});
  };

  return (
    <div
      key={item.userName}
      className="row paddingLeftRight align-items-c border-bottom">
      <div className="col-2">{item.airline}</div>
      <div className="col-1">{item.airlineCode}</div>
      <div className="col-1">{item.lastName?.toUpperCase()}</div>
      <div className="col-1">{item.firstName?.toUpperCase()}</div>
      <div className="col-3">{item.userName?.toUpperCase()}</div>
      <div className="col-2">{item.phoneNumber}</div>
      <div className="col-1">{item.faxNumber}</div>

      <div className="col-1">
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavDropdown title="..." id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => redirectToActivityLog(item)}>
                Activity Log
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() =>
                  redirectToViewFlightsForAirline(item.airlineCode)
                }>
                Flights
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={() => updateAdmin(item)}>
                Update User
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleDeleteUser(item)}>
                Delete User
              </NavDropdown.Item>              
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </div>
  );
};

export default AdministratorRow;
